import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';

const asDate = (value) => (value?.toDate ? value.toDate() : value ? new Date(value) : null);

/**
 * Texts of Yapılacaklar Listesi (`todo.*`). Status and priority labels come
 * from the shared task texts (`tasks.status`, `tasks.priority`) used by the
 * home page's "Görevlerim" window. Stored task texts stay as they are.
 */
const useTodoText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`todo.${key}`, vars), [t]);
  const statusLabel = useCallback((value) => (value ? t(`tasks.status.${value}`) : ''), [t]);
  const priorityLabel = useCallback((value) => (value ? t(`tasks.priority.${value}`) : ''), [t]);
  const formatDate = useCallback((value) => {
    const date = asDate(value);
    if (!date || Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
  }, [locale]);
  const formatDateTime = useCallback((value) => {
    const date = asDate(value);
    if (!date || Number.isNaN(date.getTime())) return '';
    return date.toLocaleString(locale, { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }, [locale]);
  /** "Ali, Ayşe +2" for the table; every name elsewhere. */
  const assigneeNames = useCallback((task, max = 2) => {
    if (task.assignees && task.assignees.length > 0) {
      const names = task.assignees.map((a) => a.name);
      if (!max || names.length <= max) return names.join(', ');
      return `${names.slice(0, max).join(', ')} ${t('todo.table.more', { count: names.length - max })}`;
    }
    return task.assigneeName || '';
  }, [t]);
  /** 'system' was stored by the automatic CV tasks. */
  const creatorLabel = useCallback((value) => (value === 'system' ? t('todo.panel.system') : value || ''), [t]);
  return { t, language, locale, label, statusLabel, priorityLabel, formatDate, formatDateTime, assigneeNames, creatorLabel };
};

export default useTodoText;
